import React, {Component} from 'react'
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import moment from "moment";
import {Button, Col, Container, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Modal, TextareaInput} from "../../../../components";
import ClaimStatusEnum from "./ClaimStatus";
import {ColumnGroup} from 'primereact/columngroup';
import PrimeDateInput from "../../../../components/date-input/PrimeDateInput";
import ClaimActivities from "./ClaimActivities";
import {SelectInput} from "../../../../components";
import DateUtil from "../../../../utils/DateUtil";
import EligibilityStatusEnum from "../../enums/EligibilityStatusEnum";
import dialog from "../../../../components/dialog/Dialog";
import ActionMenu from "../../../../components/action-menu/ActionMenu";
import ActionMenuItem from "../../../../components/action-menu/ActionMenuItem";
import PriorAuthorizationUpdateModal from "./PriorAuthorizationUpdateModal";
import ClaimStatusUpdateModal from "./ClaimStatusUpdateModal";
import ClaimStatusLogModal from "./ClaimStatusLogModal";


export default class ClaimList extends Component {

    constructor(props) {
        super(props);
        this.dataTableRef = React.createRef();
        this.state = {
            items: [],
            errorMessages: [],
            selectedFromDate: new Date(),
            selectedToDate: new Date(),
            expandedClaims: null,
            selectedItems: [],
            notesModalVisible: false
        };
    }

    componentDidMount() {
        this.retrieveItems();
    }

    onStatusFilterChange = (event) => {
        this.dataTableRef.current.filter(event, 'status', 'equals');
        this.setState({selectedStatusFilter: event  });
    }


    retrieveItems = () => {
        const fromDateValue = moment(this.state.selectedFromDate).format('YYYY-MM-DD');
        const toDateValue = moment(this.state.selectedToDate).format('YYYY-MM-DD');

        const params = {
            fromDate: fromDateValue,
            toDate: toDateValue,
            ...this.props.listParams
        };

        RemotingService.getRemoteCall(
            'api/insurance/coordinator/claimList',
            params,
            (items) => {
                this.setState({items: items});
            });
    }

    submitClaims = () => {
        const selectedClaimIds = this.state.selectedItems.map(claim => claim.id);
        RemotingService.postRemoteCall(`api/insurance/coordinator/claims/claims-submission`, selectedClaimIds, () => {
            this.retrieveItems();
        });
    }

    renderHeaders = () => {
        return <ColumnGroup>
            <Row>
                <Column selectionMode="multiple" headerStyle={{width: '3em'}} />
                <Column header="" colSpan={1}/>
                <Column header="Claim ID" colSpan={1}/>
                <Column header="Member ID" colSpan={1}/>
                <Column header="Payer ID" colSpan={1}/>
                <Column header="Receiver ID" colSpan={1}/>
                <Column header="Emirates ID" colSpan={1}/>
                <Column header="Invoice No" colSpan={1}/>
                <Column header="Speciality" colSpan={1}/>
                <Column header="Gross" colSpan={1}/>
                <Column header="Patient Payable" colSpan={1}/>
                <Column header="Net" colSpan={1}/>
                <Column header="Encounter" colSpan={5}/>
                <Column header="Diagnosis" colSpan={2}/>
                <Column header="Prior Auth No" colSpan={1}/>
                <Column header="Eligibility" colSpan={1}/>
                <Column header="Note" colSpan={1}/>
                <Column header="Status" colSpan={1}/>
                <Column header="Actions" colSpan={1}/>
            </Row>
            <Row>
                <Column header="" colSpan={1}/>
                <Column header="" headerStyle={{width: '40px'}}/>
                <Column field="claimId" filter={true} filterMatchMode="contains"/>
                <Column field="memberId" filter={true} filterMatchMode="contains"/>
                <Column field="payerId" filter={true} filterMatchMode="contains"/>
                <Column field="receiverId" filter={true} filterMatchMode="contains"/>
                <Column field="emiratesId" filter={true} filterMatchMode="contains"/>
                <Column field="invoiceNumber" filter={true} filterMatchMode="contains"/>
                <Column field="speciality" filter={true} filterMatchMode="contains"/>
                <Column field="gross"/>
                <Column field="patientPayable"/>
                <Column field="net"/>

                <Column header="Facility ID" field="facilityId" filter={true} filterMatchMode="contains"/>
                <Column header="Type" field="type"/>
                <Column header="Patient ID" field="mrn" filter={true} filterMatchMode="contains"/>
                <Column header="Start" field="start" filter={true} filterMatchMode="contains"/>
                <Column header="End" field="end"/>


                <Column header="Level" field="level"/>
                <Column header="Code" field="code"/>

                <Column field="priorAuthorizationId"/>
                <Column field="eligibilityStatus"/>
                <Column header="" colSpan={1}/>

                <Column field="status" filter={true} filterMatchMode="custom"
                        filterElement={<SelectInput className="w-100" displayProperty="name" valueProperty="key"
                                                    options={ClaimStatusEnum.toArray()} searchEnabled={false}
                                                    value={this.state.selectedStatusFilter}
                                                    onChange={event => this.onStatusFilterChange(event)}
                        />}/>

                <Column header="" colSpan={1}/>
            </Row>
        </ColumnGroup>;
    }


    claimRecordExpansionTemplate(claim) {
        return (
            <div className="appointment-expansion-wrapper row" style={{padding: "20px", animation: "fadeAnimation 1s"}}>
                <div className="col-12">
                    <ClaimActivities claim={claim} onClaimSubmitted={this.retrieveItems}/>
                </div>
            </div>
        );
    }

    payerIdTemplate(item) {
        const PAYER_LABELS = {
            'MedicalTourismSelfPay': 'Medical Tourism Self Pay',
            'MedicalTourismOther': 'Medical Tourism Other',
        };
        return PAYER_LABELS[item.payerId] || item.payerId;
    }

    statusTemplate(item) {
        return ClaimStatusEnum[item.status].name;
    }

    eligibilityStatusTemplate(item) {
        return item.eligibilityStatus ? EligibilityStatusEnum[item.eligibilityStatus].name : '';
    }

    openPriorAuthorizationModal(item) {
        dialog({
            title: "Update Prior Authorization",
            component: <PriorAuthorizationUpdateModal claimId={item.id}
                                                      priorAuthorizationId={item.priorAuthorizationId}
                                                      onSaved={this.retrieveItems}/>
        });
    }

    renderNotesModal = () => {
        return (
            <Modal visible={this.state.notesModalVisible}
                   header="Notes"
                   submitContent="Save"
                   submitAction={() => this.updateItemNotes()}
                   closeAction={() => this.setState({notesModalVisible: false})}
                   contentStyle={{minWidth: 400}}>

                <Container className={"InputModal"}>
                    <Row>
                        <Col xs={12}>
                            <TextareaInput style={{width: "100%", maxHeight: "100px"}}
                                           value={this.state.notes}
                                           onChange={(value) => this.setState({notes: value})}/>
                        </Col>
                    </Row>
                </Container>
            </Modal>
        )
    }

    openNotesModal = (item) => {
        this.setState({
            selectedItem: item,
            notes: item.comments,
            notesModalVisible: true
        });
    }

    updateItemNotes = () => {
        const {selectedItem: item, notes} = this.state;
        RemotingService.postRemoteCall(
            `api/insurance/coordinator/claim/${item.id}/notes`,
            {notes},
            () => {
                item.comments = notes;
                this.setState({notesModalVisible: false});
                this.forceUpdate();
            }, null, true, false);
    }

    notesTemplate = (item) => {
        return <Button variant={"link"} style={{color: "#84BE56", fontSize: "12px"}}
                       onClick={() => this.openNotesModal(item)}>
            <FontAwesomeIcon icon={["fas", "edit"]} size={"sm"}/> {item.comments ? "Edit Note" : "Add Note"}
        </Button>;
    }

    openStatusUpdateModal(item) {
        dialog({
            title: "Update Claim Status",
            component: <ClaimStatusUpdateModal claimId={item.id}
                                               status={item.status}
                                               onSaved={this.retrieveItems}/>
        });
    }

    openStatusLogModal(item) {
        dialog({
            title: "Status History",
            component: <ClaimStatusLogModal claimId={item.id}/>
        });
    }

    renderActions = (item) => {
        return (
            <ActionMenu id="claimactionmenu">
                <ActionMenuItem text="Update Prior Authorization"
                                onClick={() => this.openPriorAuthorizationModal(item)}/>
                <ActionMenuItem text="Update Status"
                                onClick={() => this.openStatusUpdateModal(item)}/>
                <ActionMenuItem text="Status History"
                                onClick={() => this.openStatusLogModal(item)}/>
            </ActionMenu>
        );
    }

    render() {

        return (
            <>
                <div className="float-left " style={{display: "flex"}}>
                    <PrimeDateInput showCalendarIcon variant="dialog" value={this.state.selectedFromDate} placeholder="Start Date"
                                    onChange={date => this.setState({selectedFromDate: date}, () => this.retrieveItems())}
                    />

                    <PrimeDateInput showCalendarIcon variant="dialog" value={this.state.selectedToDate} placeholder="End Date"
                                    onChange={date => this.setState({selectedToDate: date}, () => this.retrieveItems())}
                    />
                </div>
                <div className="float-right" style={{display: "flex"}}>
                    <Button disabled={this.state.selectedItems.length === 0}
                            variant="success"
                            onClick={() => this.submitClaims()}>
                        Submit Claims
                    </Button>
                </div>
                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-left">
                    </div>
                </div>
                <div style={{padding: '10px'}}>
                    <DataTable className="claimListTable" responsive headerColumnGroup={this.renderHeaders()}
                               emptyMessage={"No items found"}
                               scrollable ref={this.dataTableRef}
                               value={this.state.items}
                               onRowToggle={(e) => {
                                   this.setState({
                                       ...this.state,
                                       expandedClaims: e.data
                                   })
                               }}
                               expandedRows={this.state.expandedClaims}
                               rowExpansionTemplate={(row) => this.claimRecordExpansionTemplate(row)}
                               dataKey="id"
                               selection={this.state.selectedItems}
                               onSelectionChange={e => this.setState({selectedItems: e.value})}>
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}/>
                        <Column expander={true} style={{width: '30px'}}/>
                        <Column field="claimId" headerStyle={{width: '200px'}} style={{width: '200px', wordBreak: "break-all"}}/>
                        <Column field="memberId" style={{width: "7%" , wordWrap : "break-word"}}/>
                        <Column field="payerId" body={this.payerIdTemplate} style={{wordWrap: "break-word"}}/>
                        <Column field="receiverId"/>
                        <Column field="emiratesId" style={{width: "7%" , wordWrap : "break-word"}}/>
                        <Column field="invoiceNumber"/>
                        <Column field="speciality" style={{wordWrap: "break-word", wordBreak: "break-word"}}/>
                        <Column field="gross"/>
                        <Column field="patientPayable"/>
                        <Column field="net"/>
                        <Column field="facilityId"/>
                        <Column field="type"/>
                        <Column field="mrn" style={{wordWrap: "break-word", wordBreak: "break-all"}}/>
                        <Column field="start" body={item => item.start ? DateUtil.formatDateTime12H(item.start) : ''}/>
                        <Column field="end" body={item => item.end ? DateUtil.formatDateTime12H(item.end) : ''}/>
                        <Column field="level" style={{wordWrap: "break-word", wordBreak: "break-word"}}/>
                        <Column field="code"/>
                        <Column field="priorAuthorizationId" style={{wordWrap: "break-word", wordBreak: "break-all"}}/>
                        <Column field="eligibilityStatus" body={this.eligibilityStatusTemplate}/>
                        <Column header="Note" body={this.notesTemplate}/>
                        <Column field="status" body={this.statusTemplate}/>
                        <Column header="Actions" body={this.renderActions} style={{textAlign: "center", width: "75px"}}/>
                    </DataTable>
                </div>
                {this.renderNotesModal()}
            </>
        )
    }
}
